import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0206 10.0779L13.8759 12.9326L12.9326 13.8759L10.0779 11.0206C9.01575 11.8721 7.69459 12.3352 6.33325 12.3333C3.02125 12.3333 0.333252 9.64525 0.333252 6.33325C0.333252 3.02125 3.02125 0.333252 6.33325 0.333252C9.64525 0.333252 12.3333 3.02125 12.3333 6.33325C12.3352 7.69459 11.8721 9.01575 11.0206 10.0779ZM9.68325 9.58325C10.5293 8.71318 11.0018 7.54687 10.9999 6.33325C10.9999 3.75459 8.91125 1.66659 6.33325 1.66659C3.75459 1.66659 1.66659 3.75459 1.66659 6.33325C1.66659 8.91125 3.75459 10.9999 6.33325 10.9999C7.54687 11.0018 8.71318 10.5293 9.58325 9.68325L9.68325 9.58325Z"
      fill={props.fill}
      fillOpacity="0.63"
    />
  </svg>
);
export default SVGComponent;
